export default {
  'signup': 'Signup',
  'login': 'Login',
  'have-an-account': 'Have an account?',
  'dont-have-an-account': 'Don\'t have an account?',
  'profile': 'Profile',
  'settings': 'Settings',
  'logout': 'Logout',
  'jobs': 'Jobs',
  'jobseekers': 'Jobseekers',
  'messages': 'Messages',
  'referrals': 'Referrals',
  'wallet': 'Wallet',
  'admin': 'Admin',
  'or-new-here': 'or new here?',
  'my-jobs': 'My Jobs',
  'applicants': 'Applicants',
  'companies': 'Companies',
  'hirers': 'Hirers',
  'about': 'About'
}



// WEBPACK FOOTER //
// ./src/i18n/en/nav.js